import script from "./TaskDetailPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./TaskDetailPanel.vue?vue&type=script&lang=ts&setup=true"

import "./TaskDetailPanel.vue?vue&type=style&index=0&id=ad62b0e8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad62b0e8"]])

export default __exports__